module.exports = __webpack_public_path__ + "img/welcome_8.2dfdfb55.jpg";